import React, { ReactNode } from 'react';
import './tooltip.scss';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface TooltipInterface {
  children: ReactNode;
  info: string;
  direction?: 'top' | 'right' | 'bottom' | 'left';
  isAlignright?: boolean;
}

export const InteractiveTooltip = (props: TooltipInterface) => {
  const { children, info, direction = 'auto', isAlignright = false } = props;

  return (
    <OverlayTrigger
      trigger={['hover', 'focus']}
      placement={direction}
      overlay={
        <Tooltip
          className='interactiveTooltipInfo'
          style={isAlignright ? { marginLeft: '23px' } : {}}
        >
          {info}
        </Tooltip>
      }
    >
      <span className='interactivetooltiptarget' onMouseEnter={() => {}} onMouseLeave={() => {}}>
        {children}
      </span>
    </OverlayTrigger>
  );
};
